import { StdResponse, request } from "@/global/config/request";
import { GlobalCable } from "@/global/interface/lib-device/global-cable";


export function getGlobalCableDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalCable(data: GlobalCable, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-cables`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalCable(id: number, data: GlobalCable, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-cables/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalCable(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalCables(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-cables`, {
        params: {
            ...params,
        }
    })
}